import { URLS } from 'api/urls';
import axios, { AxiosError } from 'axios';
import { APIUtils } from 'commons/utils';
import { useMutation } from 'react-query';
import { useRecoilState } from 'recoil';
import { tokenState } from 'redux-recoil-sync.state';

export function useDeleteCmsUserMutation() {
  const [token] = useRecoilState(tokenState);

  return useMutation<void, AxiosError, string>({
    mutationFn: async (id) => {
      await axios.delete(URLS.cmsUsers(id).delete, APIUtils.tokenHeader(token!));
    },
  });
}
